/**
 * iPhone, iPod, iPad, and iPadOS (which reports as MacIntel with touch).
 * @returns {boolean}
 */
export function isIosWebKit() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (/iPad|iPhone|iPod/i.test(ua)) return true;
  return navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
}
